/* global NDEFReader */

import React, { useState } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './ModalCerrarServicios.css';
const moment = require('moment-timezone');

const ModalCerrarServicio = ({ servicio, onClose }) => {
  const [mensajePulsera, setMensajePulsera] = useState('Esperando lectura de NFC para la pulsera...');
  const [pulseraValida, setPulseraValida] = useState(false);
  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState('');
  const token = useSelector((state) => state.auth.token);
  const user = JSON.parse(localStorage.getItem('user')) || {};

  const iniciarLecturaNFC = () => {
    if ('NDEFReader' in window) {
      const reader = new NDEFReader();
      reader.scan()
        .then(() => {
          reader.onreading = (event) => {
            const record = event.message.records[0];
            const nfcData = new TextDecoder().decode(record.data);
            validarPulsera(nfcData);
          };
        })
        .catch((error) => {
          console.error('Error al iniciar NFC:', error);
          toast.error('Error al leer NFC de la pulsera.', { position: 'top-right', autoClose: 3000 });
        });
    } else {
      toast.warning('NFC no compatible con este dispositivo.', { position: 'top-right', autoClose: 3000 });
    }
  };

  const validarPulsera = async (nfc_id) => {
    if (pulseraValida) return;
    try {
      const response = await axios.get(`https://orionadministracion.com/api/pulseras/${nfc_id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const pulsera = response.data;
      if (pulsera.noColaborador === servicio.noColaborador) {
        setPulseraValida(true);
        toast.success('Pulsera validada correctamente.', { position: 'top-right', autoClose: 3000 });
      } else {
        toast.error('La pulsera no pertenece al operador del servicio.', { position: 'top-right', autoClose: 3000 });
      }
    } catch (error) {
      console.error('Error al validar pulsera:', error);
      toast.error('Error al validar la pulsera.', { position: 'top-right', autoClose: 3000 });
    }
  };

  const handleConcluirServicio = async () => {
    setLoading(true);
    setMensaje('Concluyendo servicio...');
    try {
      const updates = {
        statusServicio: 'CONCLUIDO',
        horafin: moment().tz('America/Mexico/City').format('YYYY-MM-DD HH:mm:ss'),
        usuarioFin: user.noColaborador,
      };

      await axios.put(
        `https://orionadministracion.com/api/servicios/${servicio.noServicio}`,
        updates,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      setMensaje('Servicio concluido exitosamente.');
      toast.success('Servicio concluido exitosamente', { position: 'top-right', autoClose: 3000 });
      setTimeout(() => {
        onClose();
        window.location.reload();
      }, 3000);
    } catch (error) {
      console.error('Error al concluir servicio:', error);
      setMensaje('Hubo un error al concluir el servicio. Por favor, intente nuevamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <ToastContainer />
      <div className="modal">
        <h2>Cerrar Servicio</h2>
        <div className="nfc-section">
          <button onClick={iniciarLecturaNFC}>Escanear NFC Credencial</button>
          <p>{mensajePulsera}</p>
        </div>
        <button
          onClick={handleConcluirServicio}
          disabled={!pulseraValida}
          className={`btn-concluir-servicio ${pulseraValida ? 'activo' : 'desactivado'}`}
        >
          Concluir Servicio
        </button>
        <button onClick={onClose} className="btn-cancelar">Cancelar</button>
      </div>
    </div>
  );
};

export default ModalCerrarServicio;
